import { computed, ref } from 'vue'
import { jsonEnglishLocalesContent } from '@/composables/useLocalesData'
import i18n from '@/plugins/i18n'
import { SimpleFormOptions } from '@/config'
import { getItemTitleTranslation } from '@/composables/useValidationItem'

export const SDS_CANONICAL_PREFIX = 'SEC_'
export const TDS_CANONICAL_PREFIX = 'PRODUCT_'

const NO_SPACE_NO_DOT_MIN_3 = '[^\\s.]{3,}' // 3 characters minimum
const NO_SPACE_NO_DOT = '[^\\s.]+' // 1 or more characters
const EXACTLY_ONE_DOT = '\\.'
const KEY_PATTERN = new RegExp(`^${NO_SPACE_NO_DOT_MIN_3}${EXACTLY_ONE_DOT}${NO_SPACE_NO_DOT}$`)

function getItemsOptionsFromLocalesFiles() {
  return Object.keys(jsonEnglishLocalesContent)
    .filter((key) => KEY_PATTERN.test(key))
    .map((itemKey) => {
      // eslint-disable-next-line
      // @ts-ignore
      return { name: i18n.global.t(itemKey), value: itemKey }
    })
}

const initialItemNamesFromLocalesFile = ref<SimpleFormOptions>(getItemsOptionsFromLocalesFiles())
const itemNamesFromLocalesWithCustomerTranslations = ref(
  initialItemNamesFromLocalesFile.value.map((i) => {
    return {
      name: getItemTitleTranslation(i.value),
      value: i.value,
    }
  })
)

export default function useItemNamesFromLocalesFile() {
  const itemNamesFromLocalesFile = ref(itemNamesFromLocalesWithCustomerTranslations.value)
  const allSDSItems = computed(() => {
    return itemNamesFromLocalesFile.value.filter((i) => i.value.startsWith(SDS_CANONICAL_PREFIX))
  })
  const allTDSItems = computed(() => {
    return itemNamesFromLocalesFile.value.filter((i) => i.value.startsWith(TDS_CANONICAL_PREFIX))
  })

  // This function is used to return exactly the items of the id of the level that you enter as a parameter and the possible sublevels that it could have (for example the third level)
  function getSectionItems(sectionId: string) {
    const itemsExactSection = getSectionExactItems(sectionId)
    const itemsSubSection = itemNamesFromLocalesFile.value.filter((item) =>
      item.value.startsWith(sectionId.concat('_'))
    )
    return [...itemsExactSection, ...itemsSubSection]
  }

  // This function is used to return exactly the items of the id of the section that you enter as a parameter (for example the first and second level of nodes)
  function getSectionExactItems(sectionId: string) {
    return itemNamesFromLocalesFile.value.filter((item) => item.value.split('.')[0] === sectionId)
  }

  return {
    allSDSItems,
    allTDSItems,
    itemNamesFromLocalesFile,
    getSectionItems,
    getSectionExactItems,
  }
}
